import { ChangeDetectionStrategy, Component, effect, Input, OnDestroy, signal, ViewEncapsulation } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { S25IconComponent } from "../s25-icon/s25.icon.component";

@TypeManagerDecorator("s25-ng-fading-success-msg")
@Component({
    selector: "s25-ng-fading-success-msg",
    template: `
        @if (message?.()) {
            <div class="success-msg" [class.show-msg]="isVisible()">
                <s25-ng-icon [type]="'check'"></s25-ng-icon>
                <span class="c-margin-left--quarter">{{ message() }}</span>
            </div>
        }
    `,
    styles: `
        .success-msg {
            opacity: 0;
            transition: opacity 0.5s ease-out;
            color: green;
        }

        .success-msg span {
            position: relative;
            top: 2px;
        }

        .show-msg {
            opacity: 1;
        }
    `,
    imports: [S25IconComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
})
export class S25FadingSuccessMsgComponent implements OnDestroy {
    @Input() message = signal<string>("");
    @Input() durationInMS: number = 3000;

    isVisible = signal<boolean>(false);
    private fadeTimeout: NodeJS.Timeout;
    private displayTimeout: NodeJS.Timeout;

    constructor() {
        effect(() => {
            if (this.message?.()) {
                this.startTimer();
            }
        });
    }

    startTimer() {
        this.isVisible.set(true);
        if (this.fadeTimeout) clearTimeout(this.fadeTimeout);
        if (this.displayTimeout) clearTimeout(this.displayTimeout);

        this.fadeTimeout = setTimeout(() => {
            this.isVisible.set(false);
        }, this.durationInMS);

        this.displayTimeout = setTimeout(() => {
            this.message.set("");
        }, this.durationInMS + 500);
    }

    ngOnDestroy() {
        if (this.fadeTimeout) {
            clearTimeout(this.fadeTimeout);
        }
        if (this.displayTimeout) {
            clearTimeout(this.displayTimeout);
        }
    }
}
